import { useWizard } from './WizardContext';
import { IntroScreen } from './IntroScreen';
import { QuestionScreen } from './QuestionScreen';
import { ResultsScreen } from './ResultsScreen';

export const WizardFlow = () => {
  const { currentStep, totalQuestions } = useWizard();

  // Intro screen
  if (currentStep === 0) {
    return <IntroScreen />;
  }

  // Question screens
  if (currentStep >= 1 && currentStep <= totalQuestions) {
    return <QuestionScreen />;
  }

  // Results screen
  return <ResultsScreen />;
};
